import { Navigate } from "react-router-dom";

const isAuthenticated = () => {
  return localStorage.getItem("accessToken");
};

const PrivateRoute = ({ component: Component }) => {
  return isAuthenticated() ? Component : <Navigate to="/signin" replace />;
};

export default PrivateRoute;
